export const endPoints = {
  // apiBaseUrl: 'https://accountapi-dev.bettdraft.com:5000/', //Dev Url
 apiBaseUrl: import.meta.env.VITE_API_BASE_URL, //stage Url
 api: {
   LOGIN_ENDPOINT: "admin/login",
   SIGNUP: "users/signup",    //account-management1/users/signup
   GET_BY_USERID: "users/userid", // 12  Append userid
   GET_BY_USERNAME: "users/username/", // userrname
   UPDATE_PERSONAL: "users/personal",
   UPDATE_PROFILE_IMAGE: "upload/profileimage",
   EMAIL_SUPPORT: "email/support",
   VERIFICATION_ENDPOINT: "users/validate",
   STATES: "states",
   rgTypes:'rgTypes',
   accountstatus:'accountstatus',
   playertypes:'playertypes',
   kycstatus:'kycstatus',
   UPDATE_EMAIL: "users/email",
   FORGOT_PASSWORD: "users/passwordlost/",
   GET_SPORTS_DATA: "api/sports/id", //sportsid 6046
   DELETE_USER: 'users/delete',
   ADD_USER: 'users/add',
   GET_ADMIN: 'users/admin',
   GET_ALL_USERS: 'users/all',
   GET_RISKMANAGER: 'users/riskmanager',
   //admin api section
   GET_USERS: 'users',
   GET_BETS: 'bets/all',
   Get_Block_User: 'bolck/users',
   Create_Staff: 'staff/create',
   Update_Staff: 'staff/update',
   Delete_Staff: 'staff/delete',
   get_All_Staff: 'staffs',
   get_Single_Staff: 'staff',
   GET_Action_List: 'historicalSearch',
   GET_Access_List: 'sessioneSearch',
   GET_QUESTIONS: 'questions',
   transactions: 'alltransactions',
   GET_DOCUMENTS: 'documentTypes',
   TRANSFER_SUMMARY_LIST: 'transfer/summary/list',
   TRANSFER_DETAIL_LIST: 'transfer/details/list',
   TRANSFER_SUMMARY_REPORT: 'transfer/summary/download',
   TRANSFER_DETAIL_REPORT: 'transfer/details/download',
   USERS_REPORT: 'users/download',
   USERS_BLOCK_REPORT: 'users/block/download',
   ACTION_REPORT: 'action/download',
   ACCESS_REPORT: 'access/download',
   GetUserLimit: 'user/limit/',
   SetUserLimit: 'user/limit',
   deposit: 'admin/transactions/deposit',
   withdraw: 'admin/transactions/withdrawal',
   fieldUpdate:'account/fieldupdate',
   userFieldUpdate:'user/fieldupdate',
   userSecret:'users/secret',
   userRGLimit:'user/rglimit',
   FANTASY_PROMO:'promo/get',
   FANTASY_ADD_PROMO:'promo/add',
   FANTASY_UPDATE_PROMO:'promo/update',
   GET_IMAGE:'promotions',
   ADD_IMAGE:'addpromotions',
   UPDATE_IMAGE:'updatepromotions',
   UPLOAD_BANNER:'upload/bannerimage',
   CREATE_NOTE:'note/create',
   GET_NOTES:'note/usernotes',
   DELETE_NOTE:'note/delete',
   UPDATE_NOTE:'note/update',
   GET_ALL_BONUS:'bonus/all',
   CREATE_BONUS:'bonus/create',
   UPDATE_BONUS:'bonus/update',
   GETPROVIDERS:'api/casino/providers',
   ADDPROVIDERS:'api/casino/addProvider',
   UPDATEPROVIDERS:'api/casino/updateProvider',
   DELETE_PROVIDERS:'api/casino/deleteProvider/',
   GETMENU:'api/casino/menu',
   ADDMENU:'api/casino/addMenu',
   UPDATEMENU:'api/casino/updateMenu',
   DELETE_MENU:'api/casino/deleteMenu/',
   GETGAMES:'api/casino/games',
   ADDGAMES:'api/casino/addGame',
   UPDATEGAMES:'api/casino/updateGame',
   DELETE_GAMES:'api/casino/deleteGame/',
   GETFEATUREGAMES:'api/casino/featuregames',
   ADD_FEATUREGAMES:'api/casino/addFeatureGame',
   UPDATE_FEATUREGAMES:'api/casino/updateFeatureGame',
   DELETE_FEATUREGAMES:'api/casino/deleteFeatureGame/',
   GET_PROMO:'api/casino/promosadmin',
   ADD_PROMO:'api/casino/addPromo',
   UPDATE_PROMO:'api/casino/updatePromo',
   DELETE_PROMO:'api/casino/deletePromo/',
   GET_GIFT:'api/casino/gifts',
   ADD_GIFT:'api/casino/addGift',
   UPDATE_GIFT:'api/casino/updateGift',
   DELETE_GIFT:'api/casino/deleteGift/',
   GET_POPUP:'banner/all',
   ADD_POPUP:'banner/add',
   UPDATE_POPUP:'banner/update',
   GET_PACKAGE:'api/casino/packages',
   ADD_PACKAGE:'api/casino/addcoinpackage',
   UPDATE_PACKAGE:'api/casino/updatecoinpackage',
   DELETE_PACKAGE:'api/casino/deletePackage/',
   LINK_ACCOUNT:'user/linkaccount',
   GET_LINK_ACCOUNT:'user/linkaccounts',
   DELETE_BANNER: 'promotion/delete',
   DELETE_MARKETING: 'banner/delete',
   GAMES_BY_PROVIDER:'api/casino/gamesbyprovider/',
   DELINK_ACCOUNT:'user/delete/linkaccount',
   COOL_OFF: 'user/cooloff',
   USER_EXCLUDE: 'user/exclude',
   playerStatus:'playerstatus',
   UPDATE_REDEMPTIONCLAIM:'api/casino/updatebuytrans',
   GET_REDEMPTIONCLAIM:'api/casino/giftstransaction',
   GET_PAYMENTS:'api/payments',
   WITHDRAW_TRANSACTIONS:'allwithdraw',
   TRANSACTION_UPDATE:'transactions/update',
   UPDATE_CAMPAIGN:'api/campain/update',
   CREATE_CAMPAIGN:'api/campain/create',
   GET_ALL_CAMPAIGN: 'api/campain/get',
   UPDATE_COUPON:'api/coupon/update',
   CREATE_COUPON:'api/coupon/create',
   GET_ALL_COUPON: 'api/coupon/get',
   GET_ALL_TRACKING: '/api/coupon/used',
   GET_ALL_CAMPAIGN_USERS:'api/campain/users',
   GET_ALL_COUPON_USER:'api/coupon/users',
   DELETE_COUPON:'api/coupon/delete',
   DELETE_CAMPAIGN:'api/campain/delete',
   CREATE_BULK_BOUNS:'bonus/bulkadd',
   GET_ALL_ACTIVE_CAMPAIGN:"/api/campain/getactive",
   GET_TRANSACTION_DETAILS:"transactiondetails",
   GET_OFFER_LIST:'offer/getadmin',
   ADD_OFFER:'offer/add',
   DEPOSIT_TRANSACTIONS:'alldeposit',
   RETURN_TRANSACTIONS:'transactions/return',
   UPDATE_OFFER :'/offer/update',
   CONFIGURATION:'api/configuration/all',
   CONFIGURATION_UPDATE:'api/configuration/update',
   PLAYERTYPE_BONUS:'playertypeBonus',
  PLAYERTYPE_BONUS_UPDATE:'updateplayertypeBonus',
  GET_WOF:'api/configuration/wof',
  UPDATE_WOF:'api/configuration/wof/update',
  GET_ALL_PACKAGE:'api/casino/allpackages',
  REFER_USERS:'referUsers',   
    GET_KYC_LIST:'api/kyc/users/all',
   GET_KYC_USER:'api/kyc/user/',
   UPDATE_KYC_STATUS:'api/kyc/status',

 },
 mode: "Development",
};
export const API_URL = "https://sportsfeedapis.betthouse.com/api/league/64"
export const paymentEndpoints = {
//  apiBaseUrl:  "https://dev-payment.bettdraft.com:5000/", //Dev Url
 apiBaseUrl:  import.meta.env.VITE_API_BASE_URL_PAYMENT, //Stage Url
 api: {
   ACTIVATE: "payment/enroll",
   TRANSACTION_SUMMARY_LIST: 'transaction/summary',
   TRANSACTION_DETAIL_LIST: 'transaction/detailed',
   TRANSACTION_SUMMARY_REPORT: 'transaction/summary/download',
   TRANSACTION_DETAIL_REPORT: 'transaction/detailed/download',
   deposit_WithDraw: 'payment/transfers',

 }
}

export const sportEndPoint = {
 apiBaseUrl: import.meta.env.VITE_API_BASE_URL_SPORT, //Stage Url
 api: {
   leagueByIdUrl: "api/league/",
   leagueList: "api/leagues",
   sports: "api/sports",
   GET_BETS: 'api/fantasy/all',
   EXPORT_BET_PDF: 'api/fantasy/download/pdf',
   EXPORT_BET_CSV: 'api/fantasy/download/csv',
   REPORT: 'api/fantasy/report',
   LIVE_BET_REPORT: 'api/fantasy/report/live',
   LIVE_BET_SUMMARY: 'api/fantasy/summary',
   all_bets: "api/fantasy/info",
 },
 mode: "Development",
};

export const P2PsportEndPoint = {
 apiBaseUrl: import.meta.env.VITE_API_BASE_URL_SPORT, //Stage Url
 api: {
   sports: "api/sports",
   ADD_POOLS:'api/pool/create',
   GET_POOLS:'api/pools',
   UPDATE_POOLS:"api/pool/update",
   GET_POOL_BETS:'api/fantasy/geteventpools',
   GET_POOL_RESULTS:'api/fantasy/geteventpools',
   DELETE_POOL:'api/pool/delete',
    GET_BETS: 'api/fantasy/bets/all',
    User_BETS: "api/fantasy/info",
   USER_POOL_BETS: "api/fantasy/getuserpools",
 },
 mode: "Development",
};

export default {};
